import Link from '@mui/material/Link';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { constants } from '../../constants';
import { MyMVariantLabel } from '../../ui-elements/MyMLabel';
import NotifyMessagePage from '../../ui-parts/NotifyMessagePage';

/**
 * Error Page Component
 */
const Error = (props) => {
  const location = useLocation();
  const errMessage = location.state?.message
                  ?? props.message
                  ?? (props.isNotFoundPage ? constants.Message.InvalidRequest : constants.Message.SystemError);

  return (
    <NotifyMessagePage>
      <MyMVariantLabel className='mb-3' variant='h6' >{errMessage}</MyMVariantLabel>
      <Link href={process.env.PUBLIC_URL}>Top Page</Link>
    </NotifyMessagePage>
  );
}
export default Error;
